import { render } from "./BaseTabela.vue?vue&type=template&id=56097f98&scoped=true"
import script from "./BaseTabela.vue?vue&type=script&lang=js"
export * from "./BaseTabela.vue?vue&type=script&lang=js"

import "./BaseTabela.vue?vue&type=style&index=0&id=56097f98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56097f98"]])

export default __exports__